import React from 'react';
import { Page } from 'src/components-dummy';
import { AnalyticsHeader } from './components/AnalyticsHeader/AnalyticsHeader';
import { AnalyticsContent } from './components/AnalyticsContent/AnalyticsContent';
import { IDataInsightsProps } from './types';

export const Analytics = ({ shopId }: IDataInsightsProps) => {
  return (
    <Page className='data-insights'>
      <Page.Header>
        <AnalyticsHeader />
      </Page.Header>
      <Page.Content className='data-insights'>
        <AnalyticsContent shopId={shopId} />
      </Page.Content>
    </Page>
  );
};
